import axios from "axios";

export const ValidateUserDni = async (userDni) => {
  const url = `https://credencialesclub.lavoz.com.ar/api/crm_by_document?nro_documento=${userDni}`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer 676840df68c9d332ef50e5ab48e75d5e`,
    },
  };

  try {
    const { data } = await axios(url, config);

    return data.data;
  } catch (error) {
    return error.response.data.data;
  }
};
